import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment/min/moment-with-locales";
import { enGB } from "date-fns/locale";
import { DatePickerCalendar } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import "./soccer.scss";
import Loading from "../layout/Loading";
import { Link } from "react-router-dom";

const DatePickerMatch = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [score, setScore] = useState([]);
  const [calendar, setCalendar] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FOOTBALL}/fixtures/date/${moment(
          selectedDate
        ).format("YYYY-MM-DD")}?page=1&api_token=${
          process.env.REACT_APP_API_TOKEN
        }&include=localTeam,visitorTeam,league`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setLoading(false);
          setScore(data.data);
        });
    };
    fetchdata();
  }, [selectedDate]);

  const formatInputValue = () => {
    if (!selectedDate) return "";
    return `Day: ${selectedDate.day}`;
  };

  const calshow = () => {
    setCalendar((value) => !value);
  };

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <Loading />
      </div>
    );

  const found = (a) => {
    console.log(a);
    setSelectedDate(a);
  };

  return (
    <div>
      {/* <div className="float-right">
        {" "}
        {console.log(moment(selectedDate).format("YYYY-MM-DD"))}
        {console.log("today" + moment(new Date()).format("YYYY-MM-DD"))}
        <label>
          {" "}
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)} //only when value has changed
            dateFormat="yyyy-MM-dd"
            placeholderText="End date"
          />
          <img src="https://img.icons8.com/fluent/28/000000/calendar.png" />
        </label>
      </div> */}
      {calendar === true ? (
        <>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().subtract(9, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {moment().subtract(9, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().subtract(8, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(8, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().subtract(7, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(7, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().subtract(6, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(6, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().subtract(5, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(5, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date  btn-6"
            onClick={(area) =>
              found(moment().subtract(4, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(4, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date btn-7"
            onClick={(area) =>
              found(moment().subtract(3, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(3, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date  btn-7"
            onClick={(area) =>
              found(moment().subtract(2, "days").format("YYYY-MM-DD"))
            }
          >
            {" "}
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(2, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date "
            onClick={(area) =>
              found(moment().subtract(1, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().subtract(1, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date btn-8 "
            onClick={(area) => found(moment().date())}
          >
            <span className="today-date "> {moment().date()}</span>
          </button>
          <button
            className="btn btn-date btn-9"
            onClick={(area) =>
              found(moment().add(1, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(1, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date  btn-10"
            onClick={(area) =>
              found(moment().add(2, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(2, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date "
            onClick={(area) =>
              found(moment().add(3, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(3, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date  btn-11"
            onClick={(area) =>
              found(moment().add(4, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(4, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date "
            onClick={(area) =>
              found(moment().add(5, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(5, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().add(6, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(6, "days").date()}
            </span>
          </button>
          <button
            className="btn btn-date"
            onClick={(area) =>
              found(moment().add(7, "days").format("YYYY-MM-DD"))
            }
          >
            <span className="today-date__normal ">
              {" "}
              {moment().add(7, "days").date()}
            </span>
          </button>
        </>
      ) : (
        ""
      )}
      <h5 className="mr-2">
        {calendar === true ? (
          ""
        ) : (
          <div>
            <button
              className="btn btn-date "
              onClick={(area) =>
                found(moment().subtract(3, "days").format("YYYY-MM-DD"))
              }
            >
              {" "}
              <span className="today-date__normal ">
                {" "}
                {moment().subtract(3, "days").date()}
              </span>
            </button>
            <button
              className="btn btn-date"
              onClick={(area) =>
                found(moment().subtract(2, "days").format("YYYY-MM-DD"))
              }
            >
              {" "}
              <span className="today-date__normal ">
                {" "}
                {moment().subtract(2, "days").date()}
              </span>
            </button>
            <button
              className="btn btn-date"
              onClick={(area) =>
                found(moment().subtract(1, "days").format("YYYY-MM-DD"))
              }
            >
              <span className="today-date__normal ">
                {" "}
                {moment().subtract(1, "days").date()}
              </span>
            </button>
            <button
              className="btn btn-date"
              onClick={(area) => found(moment().date())}
            >
              <span className="today-date "> {moment().date()}</span>
            </button>
            <button
              className="btn btn-date"
              onClick={(area) =>
                found(moment().add(1, "days").format("YYYY-MM-DD"))
              }
            >
              <span className="today-date__normal ">
                {" "}
                {moment().add(1, "days").date()}
              </span>
            </button>
            <button
              className="btn btn-date"
              onClick={(area) =>
                found(moment().add(2, "days").format("YYYY-MM-DD"))
              }
            >
              <span className="today-date__normal ">
                {" "}
                {moment().add(2, "days").date()}
              </span>
            </button>
            <button
              className="btn btn-date"
              onClick={(area) =>
                found(moment().add(3, "days").format("YYYY-MM-DD"))
              }
            >
              <span className="today-date__normal ">
                {" "}
                {moment().add(3, "days").date()}
              </span>
            </button>

            {/* <span className="today-date mr-3"> {moment().date()}</span> */}
          </div>
        )}

        <div className="float-right">
          <button
            className="btn btn-date btn-primary calendar"
            onClick={() => calshow()}
          >
            <img src="https://img.icons8.com/fluent/28/000000/calendar.png" />
          </button>
        </div>
      </h5>
      <br /> <br />
      <br />
      <div>
        {showloading()}
        {score.map((livedata) => {
          return (
            <div key={livedata.id}>
              {!(
                moment(selectedDate).format("YYYY-MM-DD") ===
                moment(new Date()).format("YYYY-MM-DD")
              ) ? (
                <div className="card mt-3 text-center card-curve">
                  <Link to={`/matchscore/${livedata.id}`} className="link-item">
                    <div className="row mt-3 pt-2">
                      <div className="col-sm-3">
                        <span className="float-left pl-2">
                          {" "}
                          <img
                            src={`${livedata.league.data.logo_path}`}
                            width="30px"
                            alt="logo"
                          />
                          {livedata.league.data.name}
                        </span>
                      </div>
                      <div className="col-sm-3">
                        <p className="soccer-soccer-board ">
                          <img
                            src={`${livedata.localTeam.data.logo_path}`}
                            width="30px"
                            alt="logo"
                          />
                          &nbsp;
                          {livedata.localTeam.data.name} &nbsp;&nbsp;
                        </p>
                      </div>

                      <div className="col-sm-3">
                        {" "}
                        <h5> {livedata.scores.ft_score}</h5>
                        <p className="soccer-soccer-board">
                          &nbsp;
                          <i class="far fa-clock"></i>{" "}
                          <Moment unix>
                            {livedata.time.starting_at.timestamp}
                          </Moment>
                          &nbsp;&nbsp;
                        </p>
                      </div>

                      <div className="col-sm-3">
                        <p className="soccer-soccer-board">
                          {" "}
                          <img
                            src={`${livedata.visitorTeam.data.logo_path}`}
                            width="30px"
                            alt="logo"
                          />
                          &nbsp;
                          {livedata.visitorTeam.data.name}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : (
                <h2></h2>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DatePickerMatch;
